<template>
  <div>
    <Header title="桌況" />

    <div class="main">
      <!-- {{ $store.getters.getConfig("color3") }} -->
      <van-row gutter="4">
        <van-col span="8" v-for="t in tblinfo" :key="t.key" style="margin-top: 1rem">
          <van-button
            v-bind:class="t.minute == null ? 'empty-seat' : ''"
            @click="cmdTable(t)"
          >
            <div style="width: 100%">{{ t.TblName }}</div>
            <!-- <div>{{ t.CustTotal }}位</div> -->
          </van-button>

          <div style="background-color: #eee; height: 4px; border-radius: 5px">
            <div
              v-bind:style="
                'background-color:#F56C6C;height:4px;border-radius:5px;width:' +
                getTblTimePcnt(t.minute) +
                '%'
              "
            ></div>
          </div>
        </van-col>
      </van-row>
      <div style="height: 3rem" />
    </div>

    <van-tabbar fixed placeholder>
      <van-button size="large" :loading="loading" @click="refresh"
        >立即更新 {{ time }}</van-button
      >
    </van-tabbar>

    <FrmTableInfo ref="rTableInfo" />
    <FrmOpenTable ref="rOpenTable" @open="cmdOpenTable" />
  </div>
</template>
<style scoped>
.main {
  text-align: left;
  padding: 1rem;
  line-height: 2rem;
  overflow-y: scroll;
}

.empty-seat {
  color: #5237eb;
  background-color: white;
}
.time-bar {
  color: red;
  background-color: #999;
  height: 0.6rem;
  width: 100%;
  /* border-radius: 1rem; */
}
</style>
<script>
import FrmTableInfo from "@/components/BKTable/Popup/FrmTableInfo.vue";
import FrmOpenTable from "@/components/BKTable/Popup/FrmOpenTable.vue";

export default {
  components: {
    FrmTableInfo,
    FrmOpenTable,
  },
  data() {
    return {
      tblinfo: [],
      time: "",
      loading: false,
    };
  },
  async mounted() {
    console.log("BKTable.monted");
    this.gLoading();

    var res = await this.apiGetBKMenu();
    let bkmenu = res.data;
    this.$store.state.config = bkmenu.config;
    this.$store.state.exttype = bkmenu.exttype;
    this.$store.state.bkmenu = bkmenu;
    await this.refresh();
    this.gClearLoading();

    setInterval(() => {
      this.refresh();
    }, 60 * 1000);
  },
  methods: {
    getTblTimePcnt(pMinute) {
      let percent = (pMinute / 120) * 100;
      if (percent > 100) percent = 100;
      return percent;
    },
    async refresh() {
      try {
        this.loading = true;
        var res = await this.apiGetTblinfo();
        this.tblinfo = res.data;
        this.time = this.now();
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    cmdTable(obj) {
      if (obj.minute == null) {
        this.$refs.rOpenTable.show(obj);
      } else {
        this.$refs.rTableInfo.show(obj);
      }
    },
    async cmdOpenTable(tblname, custtotal) {
      try {
        this.gLoading();
        // let ordertmp = pOrdertmp.filter((r) => r.Qty > 0);
        // console.log("ordertmp", ordertmp);
        var query = {
          tblname: tblname,
          custtotal: custtotal,
          // ordertmp: ordertmp,
        };
        console.log("query...", query);
        var res = await this.apiOpenTbl(query);
        console.log(res);
        await this.refresh();
        if (res.data == "BK35OPNTBL00000000")
          this.gMsgbox(tblname + "開桌完成").then(() => {});
        else this.gMsgbox(JSON.stringify(res.data), "開桌失敗").then(() => {});

        this.$refs.rOpenTable.close();

        this.gClearLoading();
      } catch (error) {
        console.log(error);
        this.gMsgbox(error);
        this.gClearLoading();
      }
    },
  },
};
</script>
